import { translateText } from '@/i18n'
import {
  addFuturesXSpace,
  addNewStrategy,
  addSupremeHedge,
  addTermHedging,
  getAddBb,
  getAddGrid,
  getAllCoins,
  getAllSymbolsByCoin,
  getCoinBalance,
  getFuturesAstraMinSpace,
  getFuturesMinSpace,
  getFuturesMinSpaceAll,
  getFuturesXMinSpace,
  getFuturesXMinSpaceAll,
  getIndex,
  minimumOrderListTerm,
  minimum_spot_hedging
} from '@/server/robot'
import { userCreateMartin } from '@/server/martin'

export const STRATEGY_PRODUCTS = [
  {
    key: 'astra',
    group: 'AI 智能产品',
    name: 'UPlus-Astra AI',
    shortName: 'Astra AI',
    description: 'AI识别趋势，自动选币并择时开单。',
    kind: 'astra',
    icon: 'swap',
    gradient: 'linear-gradient(135deg,#34D9B8,#0B9BA8)',
    endpoint: '/robot/addFuturesAstraSpace',
    exchanges: [1],
    minAmount: 100,
    tone: 'gold',
    badge: 'Prime 旗舰',
    tags: [
      { text: '★ Prime 旗舰', color: '#5A3E04', background: 'linear-gradient(135deg,#F9E7B3,#EFC65C)' }
    ]
  },
  {
    key: 'orbit',
    group: 'AI 智能产品',
    name: 'UPlus-Orbit AI',
    shortName: 'UPlus-Orbit AI',
    description: '全自动AI交易，适合所有行情。',
    kind: 'orbit',
    icon: 'swap',
    gradient: 'linear-gradient(135deg,#34D9B8,#0B9BA8)',
    endpoint: '/remote-strategy/add',
    exchanges: [1],
    minAmount: 1500,
    maxAmount: 10000,
    leverage: 10,
    tone: 'teal',
    badge: '首推',
    hot: true,
    tags: []
  },
  {
    key: 'futures-x-pro',
    group: 'AI 智能产品',
    name: 'UPlus-X pro',
    shortName: 'UPlus-X Pro',
    description: '主流币种 AI 合约策略，可按接口返回范围调整杠杆。',
    kind: 'vip',
    icon: 'swap',
    gradient: 'linear-gradient(135deg,#B06CF9,#7C3AED)',
    endpoint: '/robot/addFuturesXSpace',
    versionType: 2,
    exchanges: [1],
    tone: 'purple',
    badge: '推荐',
    hot: true,
    tags: []
  },
  {
    key: 'futures-x',
    group: 'AI 智能产品',
    name: 'UPlus-X',
    shortName: 'UPlus-X',
    description: '低风险合约策略，币种与最小仓位均以接口返回为准。',
    kind: 'vip',
    icon: 'swap',
    gradient: 'linear-gradient(135deg,#B06CF9,#7C3AED)',
    endpoint: '/robot/addFuturesXSpace',
    versionType: 1,
    exchanges: [1],
    tone: 'purple',
    badge: '低风险',
    tags: []
  },
  {
    key: 'hedge-standard',
    group: '合约产品',
    name: '合约AI交易',
    shortName: '合约 AI',
    description: '多空对冲震荡套利，支持止损、风险等级和最大持仓设置。',
    kind: 'hedge',
    icon: 'document',
    gradient: 'linear-gradient(135deg,#F45ED9,#C026D3)',
    endpoint: '/robot/addSupremeHedge',
    speed: 0,
    exchanges: [0, 1],
    tone: 'blue',
    badge: '标准版',
    tags: [
      { text: '年800%+', color: '#1F6BFF', background: '#EBF1FE' },
      { text: '版本 3.0', color: '#FFFFFF', background: '#101B36' }
    ]
  },
  {
    key: 'hedge-speed',
    group: '合约产品',
    name: '合约AI交易 (闪电版)',
    shortName: '合约 AI 闪电版',
    description: '闪电版合约策略，创建参数与原项目 speed=1 完全一致。',
    kind: 'hedge',
    icon: 'document',
    gradient: 'linear-gradient(135deg,#F45ED9,#C026D3)',
    endpoint: '/robot/addSupremeHedge',
    speed: 1,
    exchanges: [0, 1],
    tone: 'orange',
    badge: '闪电版',
    tags: [
      { text: '年2000%+', color: '#1F6BFF', background: '#EBF1FE' },
      { text: '主推', color: '#FFFFFF', background: 'linear-gradient(135deg,#FF8A3C,#F04D23)' }
    ]
  },
  {
    key: 'hedge-single',
    group: '合约产品',
    name: '合约AI交易 (单向版)',
    shortName: '合约 AI 单向版',
    description: '支持做多或做空，Gate.io 与 Bybit 仅开放该合约版本。',
    kind: 'hedge',
    icon: 'document',
    gradient: 'linear-gradient(135deg,#F45ED9,#C026D3)',
    endpoint: '/robot/addSupremeHedge',
    speed: 2,
    singleDirection: true,
    exchanges: [0, 1, 2, 3],
    tone: 'red',
    badge: '单向版',
    tags: [
      { text: '年1000%+', color: '#1F6BFF', background: '#EBF1FE' },
      { text: '主推', color: '#FFFFFF', background: 'linear-gradient(135deg,#FF8A3C,#F04D23)' }
    ]
  },
  {
    key: 'term-standard',
    group: '期现产品',
    name: '期现AI交易 (普通版)',
    shortName: '期现 AI 普通版',
    description: '现货与合约对冲，币种和最小仓位由期现接口实时返回。',
    kind: 'term',
    icon: 'chart',
    gradient: 'linear-gradient(135deg,#FFC24D,#F08C00)',
    endpoint: '/robot/addFuturesSpotAI',
    version: 2,
    exchanges: [0, 1],
    tone: 'green',
    badge: '普通版',
    tags: [
      { text: '年100%+', color: '#1F6BFF', background: '#EBF1FE' }
    ]
  },
  {
    key: 'term-speed',
    group: '期现产品',
    name: '期现AI交易 (闪电版)',
    shortName: '期现 AI 闪电版',
    description: '期现闪电版，提交 version=3，与原项目保持一致。',
    kind: 'term',
    icon: 'chart',
    gradient: 'linear-gradient(135deg,#FFC24D,#F08C00)',
    endpoint: '/robot/addFuturesSpotAI',
    version: 3,
    exchanges: [0, 1],
    tone: 'orange',
    badge: '闪电版',
    tags: [
      { text: '年200%+', color: '#1F6BFF', background: '#EBF1FE' }
    ]
  },
  {
    key: 'term-btc',
    group: '期现产品',
    name: '期现AI交易 (BTC 版)',
    shortName: '期现 AI BTC 版',
    description: 'BTC 专用期现版本，提交 version=5。',
    kind: 'term',
    icon: 'chart',
    gradient: 'linear-gradient(135deg,#FFC24D,#F08C00)',
    endpoint: '/robot/addFuturesSpotAI',
    version: 5,
    exchanges: [0, 1],
    tone: 'gold',
    badge: 'BTC 版',
    tags: [
      { text: '年400%+', color: '#1F6BFF', background: '#EBF1FE' }
    ]
  },
  {
    key: 'bb',
    group: '现货产品',
    name: '币币双向AI交易',
    shortName: '币币双向AI交易',
    description: '双币种交易套利，适合横盘屯币',
    kind: 'bb',
    icon: 'coin',
    gradient: 'linear-gradient(135deg,#9F8CFA,#6D5BE8)',
    endpoint: '/robot/addBb 或 /okex/addBb',
    exchanges: [0, 1],
    tone: 'purple',
    badge: '现货',
    tags: [
      { text: '年100%+', color: '#1F6BFF', background: '#EBF1FE' }
    ]
  }
  /*
  // “添加网格”和“添加马丁”暂时隐藏；需要恢复时删除本段块注释。
  , {
    key: 'grid',
    group: '现货产品',
    name: '现货网格交易',
    shortName: '现货网格交易',
    description: '震荡行情中自动低买高卖，稳定套利',
    kind: 'grid',
    icon: 'grid',
    gradient: 'linear-gradient(135deg,#5FA5F9,#1F6BFF)',
    endpoint: '/grid/addGridStrategy',
    exchanges: [0, 1],
    tone: 'blue',
    badge: '网格',
    tags: []
  },
  {
    key: 'martin',
    group: '现货产品',
    name: '现货马丁交易',
    shortName: '现货马丁交易',
    description: '单边加倍押注降低成本，回调止盈',
    kind: 'martin',
    icon: 'martin',
    gradient: 'linear-gradient(135deg,#FB8A8A,#E5484D)',
    endpoint: '/martin/addMartinStrategy',
    exchanges: [0, 1],
    tone: 'red',
    badge: '马丁',
    tags: []
  }
  */
]

const EXCHANGE_NAMES = {
  0: 'Binance',
  1: 'OKX',
  2: 'Gate',
  3: 'Bybit'
}

function asArray(value) {
  if (Array.isArray(value)) return value
  if (value && Array.isArray(value.list)) return value.list
  if (value && Array.isArray(value.records)) return value.records
  return []
}

function responseData(response) {
  if (!response) return null
  return Object.prototype.hasOwnProperty.call(response, 'data') ? response.data : null
}

function responseError(response, label) {
  if (!response) return new Error(translateText(`${label}接口未返回数据`))
  if (response.success === false) return new Error(response.message || translateText(`${label}接口请求失败`))
  return null
}

async function settle(label, request) {
  try {
    const response = await request
    const error = responseError(response, label)
    if (error) throw error
    return { data: responseData(response), response, error: null }
  } catch (error) {
    return {
      data: null,
      response: null,
      error: error && error.message ? error.message : translateText(`${label}接口请求失败`)
    }
  }
}

function finiteNumber(value) {
  if (value === '' || value === null || value === undefined) return null
  const result = Number(value)
  return Number.isFinite(result) ? result : null
}

function selectExchangeServer(robotType) {
  getIndex(Number(robotType) === 0 ? 1 : 2)
}

function firstNumber(object, keys) {
  for (const key of keys) {
    const value = finiteNumber(object && object[key])
    if (value !== null) return value
  }
  return null
}

function normalizeBalance(value) {
  const direct = finiteNumber(value)
  if (direct !== null) return direct
  return firstNumber(value, ['balance', 'available', 'availableBalance', 'amount'])
}

function normalizeCoins(value) {
  return asArray(value)
    .map(item => {
      const row = item && typeof item === 'object' ? item : { coin: item }
      const coin = row.coin_name || row.coin || row.symbol || ''
      if (!coin) return null
      return {
        coin: String(coin).toUpperCase(),
        minSpace: firstNumber(row, ['min_space', 'minSpace', 'position']),
        versionType: firstNumber(row, ['versionType', 'version_type']),
        raw: row
      }
    })
    .filter(Boolean)
}

export function getStrategyProduct(key) {
  return STRATEGY_PRODUCTS.find(item => item.key === key) || STRATEGY_PRODUCTS[0]
}

export function exchangeName(robotType) {
  return EXCHANGE_NAMES[Number(robotType)] || `交易所 ${robotType}`
}

export function normalizeExchangeRobots(rows) {
  const result = []
  const seen = new Set()

  asArray(rows).forEach(item => {
    const robotType = finiteNumber(item && item.robot_type)
    if (robotType === null || seen.has(robotType)) return
    seen.add(robotType)
    result.push({
      robotType,
      name: exchangeName(robotType),
      bindApi: finiteNumber(item && item.bind_api),
      raw: item
    })
  })

  return result
}

function productCoinRequest(product, robotType, options = {}) {
  if (product.kind === 'astra') return Promise.resolve({ success: true, data: [] })
  if (product.kind === 'vip') {
    return getFuturesXMinSpaceAll(robotType, product.versionType, 2)
  }
  if (product.kind === 'term') {
    return minimumOrderListTerm(2, robotType, product.version)
  }
  if (product.kind === 'hedge') {
    const selectedFutureType = Number(options.futureType)
    const futureType = product.singleDirection
      ? ([1, 2].includes(selectedFutureType) ? selectedFutureType : 1)
      : ''
    return getFuturesMinSpaceAll(2, robotType, product.speed === 2 ? 2 : 0, futureType)
  }
  return getAllCoins()
}

function balanceOptions(product, robotType, options = {}) {
  if (['bb', 'grid', 'martin'].includes(product.kind)) {
    return { type: 1, instType: '', futuresType: '' }
  }
  if (product.kind === 'term') {
    return {
      type: 1,
      instType: Number(robotType) === 0 ? 2 : '',
      futuresType: ''
    }
  }
  if (product.kind === 'hedge') {
    const selectedFutureType = Number(options.futureType)
    return {
      type: 1,
      instType: '',
      futuresType: product.singleDirection
        ? ([1, 2].includes(selectedFutureType) ? selectedFutureType : 1)
        : ''
    }
  }
  return { type: 1, instType: '', futuresType: '' }
}

export async function loadStrategySetup(productKey, robotType, options = {}) {
  const product = getStrategyProduct(productKey)
  const numericRobotType = Number(robotType)
  selectExchangeServer(numericRobotType)

  const balanceRequestOptions = balanceOptions(product, numericRobotType, options)
  const providedCapacity = options.capacity && typeof options.capacity === 'object'
    ? options.capacity
    : null
  const providedRobotInfo = options.robotInfo && typeof options.robotInfo === 'object'
    ? options.robotInfo
    : null

  const [balance, coins, astraMinimum, spotBalance] = await Promise.all([
    settle('交易所可用余额', getCoinBalance(
      'USDT',
      numericRobotType,
      balanceRequestOptions.type,
      balanceRequestOptions.instType,
      balanceRequestOptions.futuresType
    )),
    settle('策略币种列表', productCoinRequest(product, numericRobotType, options)),
    product.kind === 'astra'
      ? settle('Astra 最小仓位', getFuturesAstraMinSpace(numericRobotType))
      : Promise.resolve({ data: null, error: null }),
    product.kind === 'term' && numericRobotType === 0
      ? settle('Binance 现货余额', getCoinBalance('USDT', numericRobotType, 1, 1, ''))
      : Promise.resolve({ data: null, error: null })
  ])

  const normalizedCoins = normalizeCoins(coins.data)
  if (product.key === 'futures-x-pro' && !coins.error) {
    normalizedCoins.push({
      coin: '多币种综合',
      minSpace: null,
      versionType: 3,
      raw: { versionType: 3 }
    })
  }
  const astraData = astraMinimum.data && typeof astraMinimum.data === 'object'
    ? astraMinimum.data
    : {}
  const astraMinimumValue = firstNumber(astraData, ['minSpace', 'min_space'])

  return {
    product,
    robotType: numericRobotType,
    robotInfo: providedRobotInfo,
    capacity: providedCapacity,
    balance: normalizeBalance(balance.data),
    spotBalance: normalizeBalance(spotBalance.data),
    minimum: astraMinimumValue === null ? product.minAmount || null : astraMinimumValue,
    coins: normalizedCoins,
    errors: [
      providedRobotInfo ? null : '机器人页面尚未加载当前交易所状态',
      providedCapacity ? null : '机器人页面尚未加载策略可用名额',
      balance.error,
      coins.error,
      astraMinimum.error,
      spotBalance.error
    ].filter(Boolean)
  }
}
export async function loadStrategyCoinDetail(productKey, robotType, coin, options = {}) {
  const product = getStrategyProduct(productKey)
  const numericRobotType = Number(robotType)
  selectExchangeServer(numericRobotType)

  let request
  if (product.kind === 'vip') {
    const versionType = finiteNumber(options.versionType) || product.versionType
    request = getFuturesXMinSpace(
      numericRobotType,
      versionType === 3 ? '' : coin,
      versionType,
      options.lever || 10
    )
  } else if (product.kind === 'term') {
    request = minimum_spot_hedging(coin, numericRobotType, product.version)
  } else if (product.kind === 'hedge') {
    request = getFuturesMinSpace(
      coin,
      options.lever || 10,
      numericRobotType,
      options.positionProportion || 70,
      product.speed === 2 ? 2 : '',
      product.singleDirection
        ? (options.futureType === undefined ? 1 : options.futureType)
        : ''
    )
  } else {
    return { data: null, error: null }
  }

  const result = await settle('币种最小仓位', request)
  const data = result.data && typeof result.data === 'object' ? result.data : {}
  return {
    data: {
      minSpace: firstNumber(data, ['minSpace', 'min_space']),
      minSpaceTrue: firstNumber(data, ['minSpaceTrue', 'min_space_true']),
      maxLever: firstNumber(data, ['maxLever', 'max_lever'])
    },
    error: result.error
  }
}
export async function loadStrategyPositionPreview(options = {}) {
  const category = String(options.category || '')
  const robotType = Number(options.robotType)
  const coinSort = Number(options.coinSort) === 1 ? 1 : 2
  selectExchangeServer(robotType)

  const label = 'Strategy position preview'
  let request
  if (category === 'term') {
    request = minimumOrderListTerm(coinSort, robotType, Number(options.version) || 2)
  } else if (category === 'hedge') {
    request = getFuturesMinSpaceAll(
      coinSort,
      robotType,
      options.speed === 2 ? 2 : '',
      options.futureType === 1 || options.futureType === 2 ? options.futureType : ''
    )
  } else if (category === 'vip') {
    request = getFuturesXMinSpaceAll(
      robotType,
      Number(options.versionType) === 2 ? 2 : 1,
      coinSort
    )
  } else {
    return { rows: [], error: `${label} type is invalid` }
  }

  const result = await settle(label, request)
  if (result.error) return { rows: [], error: result.error }

  const rows = asArray(result.data).map(item => {
    const row = item && typeof item === 'object' ? item : {}
    return {
      coin: String(row.coin || row.coin_name || row.symbol || '--'),
      minSpace: row.min_space !== undefined ? row.min_space : row.minSpace,
      suggestedSpace: row.suggest_space !== undefined ? row.suggest_space : row.suggestSpace,
      raw: row
    }
  })

  return { rows, error: null }
}
export async function loadSpotPairs(robotType, coin) {
  selectExchangeServer(robotType)
  const result = await settle('现货交易对', getAllSymbolsByCoin(coin))
  return {
    rows: asArray(result.data),
    error: result.error
  }
}

export async function loadStrategyBalance(robotType, coin, options = {}) {
  selectExchangeServer(robotType)
  const result = await settle(
    `${coin}可用余额`,
    getCoinBalance(
      coin,
      Number(robotType),
      options.type === undefined ? 1 : options.type,
      options.instType === undefined ? '' : options.instType,
      options.futureType === undefined ? '' : options.futureType
    )
  )
  return {
    balance: normalizeBalance(result.data),
    error: result.error
  }
}

export function getSpotPairMinimums(pair, robotType) {
  const targetCoin = pair && pair.target_coin
  const costCoin = pair && pair.cost_coin
  if (!targetCoin || !costCoin) return { target: null, cost: null }

  const multiplier = 200
  if (Number(robotType) === 1) {
    return {
      target: firstNumber(pair, ['min_qty']) === null
        ? null
        : firstNumber(pair, ['min_qty']) * multiplier,
      cost: firstNumber(pair, ['min_qty_true']) === null
        ? null
        : firstNumber(pair, ['min_qty_true']) * multiplier
    }
  }

  return {
    target: firstNumber(pair, ['min_qty_true']) === null
      ? null
      : firstNumber(pair, ['min_qty_true']) * multiplier,
    cost: firstNumber(pair, ['min_notional']) === null
      ? null
      : firstNumber(pair, ['min_notional']) * multiplier
  }
}

function availabilityDate(value) {
  if (!value) return null
  const parsed = new Date(String(value).replace(/-/g, '/')).getTime()
  return Number.isFinite(parsed) ? parsed : null
}

function strategyAvailabilityRule(product) {
  if (product.kind === 'astra') {
    return {
      label: 'UPlus-Astra AI',
      usableKey: 'astra_usable',
      spaceUsableKey: 'astra_space_usable',
      startKey: 'astra_start_time',
      betaFullKey: 'astra_beta_full'
    }
  }
  if (product.kind === 'vip' && product.key === 'futures-x-pro') {
    return {
      label: 'UPlus-X Pro',
      usableKey: 'futures_x_usable',
      spaceUsableKey: 'futures_x_vip_space_usable',
      startKey: 'futures_x_vip_start_time',
      betaFullKey: 'futures_x_vip_beta_full'
    }
  }
  if (product.kind === 'vip') {
    return {
      label: 'UPlus-X',
      usableKey: 'futures_x_usable',
      spaceUsableKey: 'futures_x_space_usable',
      startKey: 'futures_x_start_time',
      betaFullKey: 'futures_x_beta_full'
    }
  }
  if (product.kind === 'hedge') {
    return { label: product.name, usableKey: 'swap_usable' }
  }
  if (product.kind === 'bb') {
    return { label: product.name, usableKey: 'spot_full_usable' }
  }
  if (['grid', 'martin'].includes(product.kind)) {
    return { label: product.name, usableKey: 'spot_semi_usable' }
  }
  return null
}

export function strategyAvailabilityIssue(productKey, capacity) {
  const product = getStrategyProduct(productKey)
  const data = capacity && typeof capacity === 'object' ? capacity : null
  const rule = strategyAvailabilityRule(product)
  // App 项目的期现策略入口只校验 API 绑定状态，
  // case 9/10/11 中的数量校验已被注释，不额外推断 term_usable。
  if (!rule) return ''
  if (!data) return translateText('策略可创建数量数据尚未加载')

  if (rule.startKey) {
    const start = availabilityDate(data[rule.startKey])
    if (start === null) {
      return translateText(`${rule.label}开放时间数据异常，暂不能创建`)
    }
    if (Date.now() < start) {
      return translateText(`${rule.label}尚未到开放时间`)
    }
  }

  if (rule.betaFullKey) {
    const betaFull = finiteNumber(data[rule.betaFullKey])
    if (betaFull === null) {
      return translateText(`${rule.label}测试名额数据异常，暂不能创建`)
    }
    if (betaFull === 1) return translateText(`${rule.label}测试名额已满`)
  }

  const usable = finiteNumber(data[rule.usableKey])
  if (usable === null) {
    return translateText(`${rule.label}可创建数量数据异常，暂不能创建`)
  }
  if (usable <= 0) {
    return translateText(`${rule.label}可创建数量已用完`)
  }

  if (rule.spaceUsableKey) {
    const spaceUsable = finiteNumber(data[rule.spaceUsableKey])
    if (spaceUsable === null) return translateText(`${rule.label}可创建仓位额度数据异常，暂不能创建`)
    if (spaceUsable <= 0) return translateText(`${rule.label}可创建仓位额度已用完`)
  }

  return ''
}

export function strategySpaceAvailabilityIssue(productKey, capacity, amount) {
  const product = getStrategyProduct(productKey)
  const rule = strategyAvailabilityRule(product)
  if (!rule || !rule.spaceUsableKey) return ''
  const data = capacity && typeof capacity === 'object' ? capacity : null
  if (!data) return translateText(`${rule.label}可创建仓位额度尚未加载`)
  const spaceUsable = finiteNumber(data[rule.spaceUsableKey])
  if (spaceUsable === null) return translateText(`${rule.label}可创建仓位额度数据异常，暂不能创建`)
  const requested = finiteNumber(amount)
  if (requested !== null && requested > spaceUsable) {
    return translateText(`${rule.label}本次投入超过剩余可创建仓位 ${spaceUsable} USDT`)
  }
  return ''
}

export function strategyCapacityAfterCreate(productKey, previousCapacity, refreshedCapacity, amount) {
  const product = getStrategyProduct(productKey)
  const rule = strategyAvailabilityRule(product)
  const previous = previousCapacity && typeof previousCapacity === 'object' ? previousCapacity : {}
  const refreshed = refreshedCapacity && typeof refreshedCapacity === 'object' ? refreshedCapacity : {}
  const next = { ...previous, ...refreshed }
  if (!rule) return next

  const previousUsable = finiteNumber(previous[rule.usableKey])
  if (previousUsable !== null) {
    const expectedUsable = Math.max(0, previousUsable - 1)
    const refreshedUsable = finiteNumber(refreshed[rule.usableKey])
    next[rule.usableKey] = refreshedUsable === null
      ? expectedUsable
      : Math.min(refreshedUsable, expectedUsable)
  }

  const requested = finiteNumber(amount)
  const previousSpace = rule.spaceUsableKey ? finiteNumber(previous[rule.spaceUsableKey]) : null
  if (rule.spaceUsableKey && previousSpace !== null && requested !== null) {
    const expectedSpace = Math.max(0, previousSpace - requested)
    const refreshedSpace = finiteNumber(refreshed[rule.spaceUsableKey])
    next[rule.spaceUsableKey] = refreshedSpace === null
      ? expectedSpace
      : Math.min(refreshedSpace, expectedSpace)
  }
  return next
}

export function createStrategy(payload) {
  const product = getStrategyProduct(payload.productKey)
  const robotType = Number(payload.robotType)
  selectExchangeServer(robotType)

  if (product.kind === 'astra') {
    return addNewStrategy(robotType, payload.amount)
  }

  if (product.kind === 'vip') {
    const versionType = Number(payload.versionType || product.versionType)
    const amount = finiteNumber(payload.amount)
    if (amount === null || amount <= 0) {
      throw new Error(translateText('请输入有效的投入金额'))
    }

    const lever = versionType === 3 ? 10 : finiteNumber(payload.lever)
    if (lever === null || lever < 1) {
      throw new Error(translateText('请输入有效的杠杆倍数'))
    }

    const coin = String(payload.coin || '').trim()
    if (versionType !== 3 && !coin) {
      throw new Error(translateText('请选择交易币种'))
    }

    const params = {
      robotType,
      space: amount,
      versionType,
      // The App fixes multi-currency comprehensive (versionType=3) at 10x.
      lever,
      stopLoss: payload.stopLoss === 5 ? 1 : payload.stopLoss === 100 ? 2 : payload.stopLoss
    }
    if (versionType !== 3) params.coin = coin
    return addFuturesXSpace(params)
  }

  if (product.kind === 'term') {
    return addTermHedging(
      payload.coin,
      payload.amount,
      robotType,
      product.version,
      payload.infinite ? '0' : payload.maxPosition
    )
  }

  if (product.kind === 'hedge') {
    const positionProportion = product.speed === 1 || product.singleDirection
      ? 100
      : payload.positionProportion
    return addSupremeHedge(
      robotType,
      payload.amount,
      payload.stopLoss,
      0,
      1,
      payload.coin,
      payload.lossTransferRate,
      positionProportion,
      product.speed,
      product.singleDirection ? payload.direction : '',
      product.singleDirection ? payload.futureType : '',
      payload.infinite ? '0' : payload.maxPosition,
      payload.lever
    )
  }

  if (product.kind === 'bb') {
    return getAddBb(
      payload.baseCoin,
      payload.quoteCoin,
      payload.baseAmount || '',
      payload.quoteAmount || '',
      robotType,
      1
    )
  }

  if (product.kind === 'grid') {
    return getAddGrid(
      payload.baseCoin,
      payload.quoteCoin,
      payload.minPrice,
      payload.maxPrice,
      payload.gridNumber,
      payload.baseAmount || '',
      payload.quoteAmount || '',
      payload.gridMode,
      robotType
    )
  }

  return userCreateMartin(
    robotType,
    payload.quoteCoin,
    payload.baseCoin,
    payload.strategyType,
    payload.trendCycle,
    payload.firstSpace,
    payload.cycleNumber,
    payload.firstMultiple,
    payload.billNumber,
    payload.stopRatio,
    payload.stopCallback,
    payload.trackStop,
    JSON.stringify(payload.replenishmentConf),
    JSON.stringify(payload.replenishmentCallback),
    payload.trackReplenishment,
    payload.fullStop,
    payload.fullStopRatio,
    payload.fullSpace,
    payload.trendCycleSwitch
  )
}
export function strategyCreateSucceeded(response, productKey) {
  if (!response) return false
  if (response.success === true) return true
  return productKey === 'astra' && response.statusCode === 'astra_add_011'
}
